<template>
	<div class="containerMain">
		<title-bar :topTitle="true"/>
		<div class="col inner" v-if="languageSummary && languageProgress">
			<title-bar title="Progreso" :percentage="languageSummary.schoolPercentage" percentageTitle="Promedio Colegio"/>
			<title-bar :title="languageSummary.itemName" :percentage="languageSummary.itemPercentage" percentageTitle="Promedio Docente"/>
			<title-bar :title="category.name" :percentage="category.percentage" percentageTitle="Promedio Categoría" :categoryId="categoryId"/>
			<div class="col full">
				<div class="row between innerRubric">
					<progress-chart v-for="question in progressionReport.questions" :key="question.id" :categoryId="categoryId" :data="question.graphData" :title="question.name" :percentage="question.percentage"/>
				</div>
			</div>
		</div>
		<div class="col inner" v-else>
			<spinner :isMiniSpinner="true"/>
		</div>
	</div>
</template>

<script>
import helpers from '@/helpers';
import mediator from '@/mediator';

export default {
	props: ['isoCode', 'categoryId'],
	mounted () {
		setTimeout(() => {
			mediator.showContent();
		}, 1000);
	},
	computed: {
		languageSummary () {
			if (this.$store.state.languages.summary) return this.$store.state.languages.summary.find((item) => {
				return item.itemId == this.isoCode;
			});
			else return this.$store.state.languages.summary;
		},
		languageProgress () {
			if (this.$store.state.languages.progress) return this.$store.state.languages.progress.find((item) => {
				return item.language.isoCode == this.isoCode;
			}).progress;
			else return this.$store.state.languages.progress;
		},
		category () {
			if (this.languageSummary) return this.languageSummary.coachingCategories.find((category) => {
				return category.id == this.categoryId;
			});
			else return this.languageSummary;
		},
		progressionReport () {
			if (!this.category) return [];
			this.category.questions.forEach((coachingQuestion) => {
				coachingQuestion.graphData = {
					labels: this.languageProgress.map((visit) => {
						let result = null;
						visit.coachingCategories.forEach((category) => {
							if (category.id == this.categoryId) {
								category.questions.forEach((question) => {
									if (question.id == coachingQuestion.id) result = parseInt(question.percentage);
								});
							}
						});
						if (result) return `Visita ${visit.number}: ${result}%`;
						else return `Visita ${visit.number}`;
					}),
					datasets:	[{
						data: this.languageProgress.map((visit) => {
							let result = null;
							visit.coachingCategories.forEach((category) => {
								if (category.id == this.categoryId) {
									category.questions.forEach((question) => {
										if (question.id == coachingQuestion.id) result = parseInt(question.percentage);
									});
								}
							});
							return result;
						}),
						borderWidth: 2,
						dates: this.languageProgress.map((visit) => {
							return this.getHumanDate(visit.date);
						})
					}]
				};
			});
			return this.category;
		}
	},
	methods: {
		getHumanDate (date) {
			return helpers.dateTime.getHumanDate(date);
		}
	}
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/routes/languages/CategoryProgress.vue